<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="notifications.length > 0 ? notifications.length + '+' : ''"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
        :disabled="!notifications || notifications.length === 0"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          Notifications
        </h4>
        <b-badge
          pill
          variant="light-primary"
        >
          {{ notifications.length > 0 ? notifications.length + '+' : '0 Notification' }} New
        </b-badge>
      </div>
    </li>

    <b-spinner
      v-if="loading"
      label="Loading..."
    />

    <!-- Notifications -->
    <vue-perfect-scrollbar
      v-else
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <!-- Account Notification -->
      <b-link
        v-for="notification in notifications"
        :key="notification.notificationId"
        style="cursor: auto;"
      >
        <b-media>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ notification.content }}
            </span>
          </p>
          <small class="notification-text">{{ notification.source }} - {{ notification.contentDate }}</small>
        </b-media>
      </b-link>
    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li class="dropdown-menu-footer">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
        @click="$router.push('/notifications')"
      >
        See all notifications
      </b-button>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton, BFormCheckbox, BSpinner,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      notifications: [],
      loading: true,
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
        wheelSpeed: 0.1
      }

    }
  },
  mounted() {
    this.getNotifications()
  },
  methods: {
    async getNotifications() {
      const postParams = {
        numberOfNotification:4
      };
      try {
        const { data } = await this.$http.post('notifications/get', postParams)
        this.notifications = data
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>


<style>

.dropdown-menu-media {
  min-width: 500px;
  position: absolute;
}
</style>
